import { keyBy, mapValues } from 'lodash';
import { type ReactNode, useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { useExportLabels } from '~/hooks/useExportTerminologyEnabled';
import rootStore from '~/store';
import { resolveActionLabel, SECTIONS } from '../roles';

interface Props {
  role: string;
}

export default function RolePermissions({ role }: Props) {
  const { currentOrganizationDetail } = useSnapshot(rootStore);
  const labels = useExportLabels();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const content = useMemo(() => {
    if (currentOrganizationDetail.isLoading) {
      return null;
    } else {
      const theRole = keyBy(currentOrganizationDetail.roles, 'roleId')[role];
      const result: ReactNode[] = [];
      mapValues(SECTIONS, (section) => {
        section.actions.forEach((action) => {
          const label = resolveActionLabel(action, labels);
          if (theRole.actions.includes(action.id)) {
            result.push(<div key={action.id}>✅ {label}</div>);
          } else {
            result.push(<div key={action.id}>❌ {label}</div>);
          }
        });
      });
      return result;
    }
    // Depend on the resolved string, not `labels` — that object is new every render.
    // Flags arrive after first paint, so without this the list freezes on pre-flag copy.
  }, [role, labels.rolePermissionLabel]);

  return <div className="h-[40vh] overflow-y-auto py-4">{content}</div>;
}
